export default {
  appointmentBlockContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
  },
  appointmentBlockItem: {
    paddingRight: '5px',
    whiteSpace: 'nowrap',
  },
  appointmentBlockDateTime: {},
  appointmentBlockLocation: {},
  appointmentBlockProvider: {},
  appointmentOffsetAppointment: {
    position: 'relative',
    // fontStyle: 'italic',
    // fontWeight: 'bold',
    paddingLeft: '22px',
  },
  appointmentOfferAlert: {
    position: 'absolute',
    left: 0,
    top: '1px',
  },
  // Transparent border + reserved icon space on every row keeps layout stable when selection adds the check icon.
  appointmentRowBorder: {
    border: '2px solid transparent',
    paddingRight: '32px',
  },
  // Non-color cue for a selected time slot (border + bold text + check icon).
  appointmentSelectedItem: {
    borderColor: 'rgb(115, 64, 170)',
    fontWeight: 700,
  },
  // Absolutely positioned in the reserved space so it never pushes row text.
  appointmentSelectedIcon: {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: 'rgb(115, 64, 170)',
  },
};
